<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDateLocale } from 'dashboard/composables/useTimeAgo';
import ReportCards from './ReportCards.vue';

const props = defineProps({
  report: { type: Object, default: null },
  loading: { type: Boolean, default: false },
});

const { t } = useI18n();
const { localeTag } = useDateLocale();
const numberFormatter = new Intl.NumberFormat(localeTag.value);

function formatDuration(seconds) {
  if (!seconds || seconds <= 0) return '—';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h >= 24) return `${Math.floor(h / 24)}d ${h % 24}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

const cards = computed(() => [
  {
    key: 'replies',
    label: t('CAMPAIGN.REPORTS.ENGAGEMENT.REPLIES'),
    value: numberFormatter.format(props.report?.engagement?.replies ?? 0),
    description: t('CAMPAIGN.REPORTS.ENGAGEMENT.REPLIES_DESC'),
  },
  {
    key: 'reactions',
    label: t('CAMPAIGN.REPORTS.ENGAGEMENT.REACTIONS'),
    value: numberFormatter.format(props.report?.engagement?.reactions ?? 0),
    description: t('CAMPAIGN.REPORTS.ENGAGEMENT.REACTIONS_DESC'),
  },
  {
    key: 'avg_reply',
    label: t('CAMPAIGN.REPORTS.ENGAGEMENT.AVG_REPLY'),
    value: formatDuration(props.report?.engagement?.avg_reply_seconds),
    description: t('CAMPAIGN.REPORTS.ENGAGEMENT.AVG_REPLY_DESC'),
  },
]);
</script>

<template>
  <ReportCards
    :cards="cards"
    :loading="loading"
    :columns="3"
    :skeleton-count="3"
  />
</template>
